module.exports = __webpack_public_path__ + "static/media/whoNeedsPrintLonger.0f43b340.jpg";